import { Select, MenuItem } from "@mui/material";
import { GridFilterInputValueProps } from "@mui/x-data-grid";
import { SelectChangeEvent } from "@mui/material/Select";
import { useSkills } from "../../../../hooks/useSkills";


export function FilterSkillInput(props: GridFilterInputValueProps) {
  const { item, applyValue } = props;
  const {
    skills
  } = useSkills();
  const handleChange = (event: SelectChangeEvent) => {
    applyValue({ ...item, value: event.target.value });
  };

  return (
    <Select
      value={item.value || ""}
      onChange={handleChange}
      displayEmpty
      fullWidth
    >
      <MenuItem value="">All</MenuItem>
      {skills.map((skill: any) => (
        <MenuItem key={skill.name} value={skill.name}>
          {skill.name}
        </MenuItem>
      ))}
    </Select>
  );
}